import { render } from "./SubscribePlanItemCompareHeader.vue?vue&type=template&id=0a8c3161"
import script from "./SubscribePlanItemCompareHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribePlanItemCompareHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Subscribe/SubscribePlanItemCompareHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a8c3161"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a8c3161', __exports__)) {
    api.reload('0a8c3161', __exports__)
  }
  
  module.hot.accept("./SubscribePlanItemCompareHeader.vue?vue&type=template&id=0a8c3161", () => {
    api.rerender('0a8c3161', render)
  })

}


export default __exports__